import styled from 'styled-components'

import type { DistributionProps } from './distribution'

export const DistributionLine = (props: DistributionProps) => {
  const segments = props.distribution.filter(
    (segment) => segment.percentageValue && segment.percentageValue > 0,
  )
  return (
    <Root>
      {segments.length > 0 ? (
        segments.map((segment, index) => (
          <Segment
            key={index}
            $width={segment.percentageValue ?? 0}
            $color={segment.color}
            $border={segment.border}
          />
        ))
      ) : (
        <EmptySegment
          $width={1}
          $color={'var(--backgroundA-3)'}
          $border={'transparent'}
        />
      )}
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  gap: 2px;
`
const Segment = styled.div<{ $color: string; $border: string; $width: number }>`
  flex: ${({ $width }) => $width};
  background: ${({ $color }) => $color};
  border: 1px solid ${({ $border }) => $border};
  height: 38px;
  border-radius: 4px;
`
const EmptySegment = styled(Segment)`
  background:
    repeating-linear-gradient(
      -45deg,
      rgba(var(--background-6-rgb), 0.1),
      rgba(var(--background-6-rgb), 0.1) 10px,
      transparent 10px,
      transparent 20px
    ),
    var(--appearanceA-5, var(--appearanceA-5));
`
